import React, { useState, useEffect, useRef } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Appqr from '../../components/Appqr';
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./BrandPartnership.css";
import loader from '../../assests/loader.gif';

const images1 = [ 
  "assests/images/new-ow-img1.png", 
  "assests/images/new-ow-img2.png",
  "assests/images/new-ow-img88.jpg", 
  "assests/images/new-ow-img99.jpg", 
  "assests/images/new-ow-img999.jpg", 
  "assests/images/Centra.mp4",
]; 

const images2 = [ 
  "assests/images/new-ow-img3.png", 
  "assests/images/new-ow-img4.png", 
  "assests/images/new-ow-img11.jpg", 
  "assests/images/new-ow-img22.jpg", 
  "assests/images/new-ow-img33.jpg", 
  "assests/images/new-ow-img44.jpg",
]; 

const images3 = [ 
  "assests/images/new-ow-img5.png", 
  "assests/images/new-ow-img6.png", 
  "assests/images/new-ow-img55.jpg", 
  "assests/images/new-ow-img66.jpg", 
  "assests/images/new-ow-img77.jpg", 
];

const BrandPartnership = () => {
  const [currentIndex1, setCurrentIndex1] = useState(0);
  const [currentIndex2, setCurrentIndex2] = useState(0);
  const [currentIndex3, setCurrentIndex3] = useState(0);
  
  const sliderRef1 = useRef(null);
  const sliderRef2 = useRef(null);
  const sliderRef3 = useRef(null);

  const settings1 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    beforeChange: (oldIndex, newIndex) => setCurrentIndex1(newIndex),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0',
        }
      }
    ]
  };

  const settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    beforeChange: (oldIndex, newIndex) => setCurrentIndex2(newIndex),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0',
        }
      }
    ]
  };

  const settings3 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    beforeChange: (oldIndex, newIndex) => setCurrentIndex3(newIndex),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0',
        }
      }
    ]
  };

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = `YFMF Brand Partnerships & Sponsorships`;
    document.getElementById('bodywrap').className = 'brand';

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute("content", "Partner with YFMF for brand activations, sponsorships and collaborations at Ireland’s most popular singles events.");
    }
    setLoading(false);
  }, []);

 

  


  return (
    <>
      <Header />
      <div className="hello-worldss d-flex justify-content-center align-items-center">
        {/* Desktop Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + 'assests/images/brand-partnew.jpg'}
          alt=""
          className="img-fluid omagu123"
        />
      </div>

      <div className="container-fluid ireland">
        <div className="row g-4">
          <div className="col-md-6 ire-left">
            <p>WORK WITH US</p>
            <h2>Brand Partnerships & Collaborations</h2>
          </div>

          <div className="col-md-6 ire-right">
            <p>
              We believe in creating events that not only bring singles together
              but also showcase the best our cities have to offer. That’s why
              we’re excited to partner with brands and venues that share our
              passion for building meaningful connections.
            </p>
            <div className="arrive">
              <a
                href="mailto:samanthakeating@yourfriendmyfriend.ie"
                className="btn bros-bu text-decoration-none"
              >
                GET IN TOUCH
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid expand new-real-new">
        <div className="row align-items-strech d-flex">
          {/* Left Side Content */}
          <div className="col-md-6 d-flex flex-column justify-content-between">
            <div className="tired">
              <h2>PARTNERSHIP</h2>
              <h4>Why Partner with YFMF?</h4>
            </div>
            <div className="tired-2">
              <Link
                to="/contact"
                className="brow-bu text-decoration-none d-none d-md-inline-block"
              >
                GET IN TOUCH
              </Link>
            </div>
          </div>

          {/* Right Side Features */}
          <div className="col-md-6 d-flex flex-column">
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/brand-1.svg'}
                alt="Previous"
                className="img-fluid"
              />
              <div>
                <h5>Expand Your Reach</h5>
                <p>
                  Introduce your brand to a vibrant audience of sociable, active
                  individuals.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/brand-2.svg'}
                alt="Previous"
                className="img-fluid"
              />
              <div>
                <h5>Boost Engagement</h5>
                <p>
                  Connect directly with attendees through event sponsorships,
                  product placements, and activations.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/brand-3.svg'}
                alt="Previous"
                className="img-fluid"
              />
              <div>
                <h5>Local Impact</h5>
                <p>
                  Collaborate with us to create memorable experiences while
                  highlighting your venue or brand’s unique character.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat locats">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/brand-4.svg'}
                alt="Previous"
                className="img-fluid"
              />
              <div>
                <h5>Creative Opportunities</h5>
                <p>
                  From co-branded events to exclusive sponsorships, we’re open
                  to ideas that bring value to everyone involved.
                </p>
              </div>
            </div>
          </div>

          <div className="d-flex d-md-none order-4 tired-2 mt-3 text-center">
            <Link
              to="/contact"
              className="brow-bu text-decoration-none w-100"
            >
              GET IN TOUCH
            </Link>
          </div>
        </div>
      </div>

      <section className="container-fluid brands-partnered">
          <h2 className="brands-title">Brands we have partnered with</h2>

          <div className="row align-items-center">
            <div className="col-6 col-lg-4 col-xl d-flex justify-content-center justify-content-md-start">
              <img src={process.env.REACT_APP_BASE_URL + "assests/images/anpost.png"} className="img-fluid brand-logo" alt="An Post" />
            </div>
            <div className="col-6 col-lg-4 col-xl">
              <img src={process.env.REACT_APP_BASE_URL + "assests/images/guinness.png"} className="img-fluid brand-logo" alt="Guinness" />
            </div>
            <div className="col-12 col-lg-4 col-xl d-flex justify-content-center justify-content-md-center">
              {/* justify-content-start justify-content-md-center */}
              <img src={process.env.REACT_APP_BASE_URL + "assests/images/fishermans-friend.png"} className="img-fluid brand-logo" alt="Fisherman's Friend" />
            </div>
            <div className="col-6 col-lg-4 col-xl d-flex justify-content-center justify-content-md-center">
              <img src={process.env.REACT_APP_BASE_URL + "assests/images/olmeca.png"} className="img-fluid brand-logo" alt="Olmeca" />
            </div>
            <div className="col-6 col-lg-4 col-xl d-flex justify-content-center justify-content-md-center">
              <img src={process.env.REACT_APP_BASE_URL + "assests/images/joe-media-group.png"} className="img-fluid brand-logo" alt="Joe Media Group" />
            </div>
          </div>

          <div className="row align-items-center mt-4">
            <div className="col-12 col-lg-3 col-xl d-flex justify-content-center justify-content-md-start">
              <img src={process.env.REACT_APP_BASE_URL + "assests/images/muller-myprotein.png"} className="img-fluid brand-logo" alt="Muller and MyProtein" />
            </div>
            <div className="col-6 col-lg-3 col-xl d-flex justify-content-center justify-content-md-center">
              <img src={process.env.REACT_APP_BASE_URL + "assests/images/centra.png"} className="img-fluid brand-logo" alt="Centra" />
            </div>
            <div className="col-6 col-lg-3 col-xl d-flex justify-content-start justify-content-md-center">
              <img src={process.env.REACT_APP_BASE_URL + "assests/images/punchestown.png"} className="img-fluid brand-logo" alt="Punchestown" />
            </div>
            <div className="col-12 col-lg-3 col-xl d-flex justify-content-center justify-content-md-center">
              <img src={process.env.REACT_APP_BASE_URL + "assests/images/lovin-dublin.png"} className="img-fluid brand-logo" alt="Lovin Dublin" />
            </div>
          </div>
      </section>

      <div className="container-fluid real-connection new-real pt-5">
        <h2 className="main-heads">Partnership Events & Activations</h2>
        <div className="row g-3 justify-content-between">
          <div className="col-md-4 d-flex flex-column justify-content-between">
            <div className="slidees ols">
              <h6>PARTNERSHIP</h6>
              <h2>"Loyalty that Loves You Back" Partnership with MyCentra</h2>
              <p>
                Your Friend My Friend partnered with Centra for "Loyalty That Loves You Back," a singles event held at Old Fashioned Sam's in Dublin. Bringing together 250 singles, the night was hosted by American influencer and comedian Theresa Rowley, alongside Clóda Scanlon. 
              </p>
              <p>
                The collaboration reimagined everyday loyalty as a playful lens on modern dating. It's one example of how YFMF partners with brands to create original, experience-led activations rather than one-off sponsorships. The night reflected what YFMF does best: turning a simple concept into a shared, memorable experience for hundreds of singles at once.
              </p>
            </div>
            <div className="d-none d-md-flex justify-content-start">
              <button
                className="btn ps-0"
                onClick={() => sliderRef1.current.slickPrev()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Previous"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Previous Hover"
                  />
                </div>
              </button>
              <button
                className="btn"
                onClick={() => sliderRef1.current.slickNext()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Next"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Next Hover"
                  />
                </div>
              </button>
            </div>
          </div>

          <div className="col-md-8 pe-md-0">
            <div className="slidexoxo new-slide">
              {/* <Slider ref={sliderRef1} {...settings1}>
                {images1.map((img, i) => (
                  <div key={i} className={`custom-slide new ${i === images1.length - 1 ? 'last-slide' : ''} ${i === currentIndex1 + 1 ? 'second-visible' : ''}`} >
                    <img
                      src={process.env.REACT_APP_BASE_URL + img}
                      className="img-fluid respo"
                      alt={`Slide ${i}`}
                      style={{ width: "100%", height: "600px", borderRadius: 24, objectFit: "cover" }}
                      onError={(e) => (e.target.style.display = "none")}
                    />
                  </div>
                ))}
              </Slider> */}

              <Slider ref={sliderRef1} {...settings1}>
                {images1.map((media, i) => {
                  const isVideo = /\.(mp4|webm|ogg)$/i.test(media);

                  return (
                    <div
                      key={i}
                      className={`custom-slide new ${i === images1.length - 1 ? 'last-slide' : ''} ${i === currentIndex1 + 1 ? 'second-visible' : ''}`}
                    >
                      {isVideo ? (
                        <video
                          className="img-fluid respo"
                          style={{
                            width: "100%",
                            height: "600px",
                            borderRadius: 24,
                            objectFit: "cover"
                          }}
                          autoPlay
                          muted
                          playsInline
                          preload="metadata"
                        >
                          <source
                            src={process.env.REACT_APP_BASE_URL + media}
                            type="video/mp4"
                          />
                          Your browser does not support the video tag.
                        </video>
                      ) : (
                        <img
                          src={process.env.REACT_APP_BASE_URL + media}
                          className="img-fluid respo"
                          alt={`Slide ${i}`}
                          style={{
                            width: "100%",
                            height: "600px",
                            borderRadius: 24,
                            objectFit: "cover"
                          }}
                          onError={(e) => (e.target.style.display = "none")}
                        />
                      )}
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>

          <div className="col-12 d-flex d-md-none justify-content-between mt-3 p-0">
            <button
              className="btn"
              onClick={() => sliderRef1.current.slickPrev()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Previous"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Previous Hover"
                />
              </div>
            </button>
            <button
              className="btn"
              onClick={() => sliderRef1.current.slickNext()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Next"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Next Hover"
                />
              </div>
            </button>
          </div>
        </div>

        <div className="bet-line"></div>

        <div className="row g-3 justify-content-between">
          <div className="col-md-8 pe-md-0 order-2 order-md-1">
            <div className="slidexoxo new-slide">
              <Slider ref={sliderRef2} {...settings2}>
                {images2.map((img, i) => (
                  <div key={i} className={`custom-slide new ${i === images2.length - 1 ? 'last-slide' : ''} ${i === currentIndex2 + 1 ? 'second-visible' : ''}`} >
                    <img
                      src={process.env.REACT_APP_BASE_URL + img}
                      className="img-fluid respo"
                      alt={`Slide ${i}`}
                      style={{ width: "100%", height: "600px", borderRadius: 24, objectFit: "cover" }}
                      onError={(e) => (e.target.style.display = "none")}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
          
          <div className="col-md-4 d-flex flex-column justify-content-between order-1 order-md-2">
            <div className="slidees ols">
              <h6>PARTNERSHIP</h6>
              <h2>"Send Love" – A Valentine’s Partnership with An Post</h2>
              <p>
                For Valentine’s Day, Your Friend, My Friend partnered with An Post to create “Send Love”, a unique event blending fitness and meaningful connections. During a 5KM Singles Run Club, participants stopped along the route to write and send a personalised postcard to a loved one, courtesy of An Post. After the run, singles gathered at a local coffee shop for coffee, treats, and conversation. With over 80 singles participating and hundreds of postcards sent across Ireland, the campaign reinforced An Post’s message of connection while generating strong brand engagement through social media and word-of-mouth.
              </p>
            </div>
            <div className="d-none d-md-flex justify-content-end">
              <button
                className="btn"
                onClick={() => sliderRef2.current.slickPrev()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Previous"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Previous Hover"
                  />
                </div>
              </button>
              <button
                className="btn"
                onClick={() => sliderRef2.current.slickNext()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Next"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Next Hover"
                  />
                </div>
              </button>
            </div>
          </div>

          <div className="col-12 d-flex d-md-none justify-content-between mt-3 p-0 order-3">
            <button
              className="btn"
              onClick={() => sliderRef2.current.slickPrev()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Previous"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Previous Hover"
                />
              </div>
            </button>
            <button
              className="btn"
              onClick={() => sliderRef2.current.slickNext()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Next"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Next Hover"
                />
              </div>
            </button>
          </div>
        </div>

        <div className="bet-line"></div>

        <div className="row g-3 justify-content-between">
          <div className="col-md-4 d-flex flex-column justify-content-between">
            <div className="slidees ols">
              <h6>PARTNERSHIP</h6>
              <h2>YFMF x Guinness Brand Events Partnership</h2>
              <p>
                Your Friend, My Friend partnered with Guinness, two great Irish brands coming together with a shared belief in bringing people together. The collaboration ran across a series of singles events throughout summer and autumn 2026, including run clubs, a pub quiz night, and a end of summer BBQ in Dublin. Guinness and Guinness 0.0 featured throughout, giving hundreds of singles a chance to connect over shared experiences rather than a typical night out. The partnership also includes a wider content series capturing real moments from the YFMF community as the events unfold. It's a natural pairing — one brand built on connection over a pint, the other built on connection, full stop.
              </p>
            </div>
            <div className="d-none d-md-flex justify-content-start">
              <button
                className="btn ps-0"
                onClick={() => sliderRef3.current.slickPrev()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Previous"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Previous Hover"
                  />
                </div>
              </button>
              <button
                className="btn"
                onClick={() => sliderRef3.current.slickNext()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Next"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Next Hover"
                  />
                </div>
              </button>
            </div>
          </div>

          <div className="col-md-8 pe-md-0">
            <div className="slidexoxo new-slide">
              <Slider ref={sliderRef3} {...settings3}>
                {images3.map((img, i) => (
                  <div key={i} className={`custom-slide new ${i === images3.length - 1 ? 'last-slide' : ''} ${i === currentIndex3 + 1 ? 'second-visible' : ''}`} >
                    <img
                      src={process.env.REACT_APP_BASE_URL + img}
                      className="img-fluid respo"
                      alt={`Slide ${i}`}
                      style={{ width: "100%", height: "600px", borderRadius: 24, objectFit: "cover" }}
                      onError={(e) => (e.target.style.display = "none")}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          <div className="col-12 d-flex d-md-none justify-content-between mt-3 p-0">
            <button
              className="btn"
              onClick={() => sliderRef3.current.slickPrev()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Previous"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Previous Hover"
                />
              </div>
            </button>
            <button
              className="btn"
              onClick={() => sliderRef3.current.slickNext()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Next"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Next Hover"
                />
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* <div className="container-fluid owned pb-5">
        <div className="get-miss">
          <div className="row d-flex align-items-strech g-4">
            <div className="col-md-4 od-2 d-flex">
              <div className="get-app d-flex flex-column flex-grow-1 horiz">
                <div className="tired">
                  <h2>JOIN US</h2>
                  <h4>Become a YFMF Host or collaborate with our Brand</h4>
                </div>
                <div className="tired-2 mt-auto">
                  <p className="mb-0 text-start">
                    Are you outgoing, energetic, and love connecting with
                    people? Do you have an entrepreneurial mindset and a passion
                    for creating unforgettable experiences? If so, we’d love to
                    have you on our team as a YFMF Host!
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-8 od-1 d-flex">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/become-new.png'}
                alt="Event Promo"
                className="img-fluid eve-img"
              />
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="container-fluid eventss year-op pt-0">
        <div className="row g-3 align-items-stretch">
          <div className="col-md-4 img-col d-flex">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/night.png'}
              alt="Event"
              className="img-fluid single"
            />
          </div>

          <div className="col-md-4 img-cols d-flex">
            <div className="testimonial-box">
              <div className="tes-1 flex-grow-1">
                <p>
                  We’re looking for individuals in Dublin, Cork, and Galway to
                  help us host the hottest singles events in their cities. As
                  the face of Your Friend My Friend, you’ll play a key role in
                  creating fun, memorable nights that bring people together!
                </p>
              </div>
              <div className="tes-2">
                <Link
                  to="/contact"
                  className="btn text-decoration-none"
                >
                  GET IN TOUCH
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-4 img-colss d-flex">
            <div className="row w-100 flex-grow-1">
              <div className="col-12 d-flex flex-column">
                <div className="stats-box flex-grow-1 mb-3 d-flex flex-column justify-content-center">
                  <h3>87</h3>
                  <p>sold out events in 2024</p>
                </div>
                <div className="stats-box flex-grow-1 mb-3 d-flex flex-column justify-content-center">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/winner.png'}
                    alt="Event"
                    className="img-fluid mb-3 win"
                  />
                  <p>Winner of Top new emerging Business in Ireland 2025</p>
                </div>
                <div className="stats-box flex-grow-1 d-flex flex-column justify-content-center">
                  <h3>10,000+</h3>
                  <p>event attendees in 2024</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="container-fluid expand new-expa">
        <div className="row align-items-strech d-flex">
          <div className="col-md-6 d-flex flex-column justify-content-between">
            <div className="tired">
              <h2>WORK WITH US</h2>
              <h4>What’s in it for you?</h4>
            </div>
            <div className="tired-2">
              <Link
                to="/contact"
                className="brow-bu text-decoration-none d-none d-md-inline-block"
              >
                GET IN TOUCH
              </Link>
            </div>
          </div>

          <div className="col-md-6 d-flex flex-column">
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/with-1.svg'}
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Competitive Pay</h5>
                <p>Earn a generous rate for each event you host.</p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/with-2.svg'}
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Professional Growth</h5>
                <p>
                  Expand your professional and social network as you connect
                  with venues, brands and singles in your city.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/with-3.svg'}
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Supportive Team</h5>
                <p>
                  Join a hardworking, fun, and collaborative team that’s
                  dedicated to helping you succeed.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat locats">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/with-4.svg'}
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Be the face of YFMF</h5>
                <p>
                  Take pride in bringing YFMF events to life and making a
                  positive impact on your community.
                </p>
              </div>
            </div>
          </div>

          <div className="d-flex d-md-none order-4 tired-2 mt-3 text-center">
            <Link
              to="/contact"
              className="brow-bu text-decoration-none w-100"
            >
              GET IN TOUCH
            </Link>
          </div>
        </div>
      </div> */}

      {/* <div className="container-fluid outgoing">
        <h1>WORK WITH US</h1>
        <h2>What we’re looking for</h2>
        <div className="row g-4">
          <div className="col-md-6 col-lg-3 d-flex">
            <div className="card flex-grow-1 fori">
              <h5>Outgoing Personality</h5>
              <p>You love meeting new people and making them feel welcome.</p>
            </div>
          </div>

          <div className="col-md-6 col-lg-3 d-flex">
            <div className="card flex-grow-1 fori">
              <h5>Entrepreneurial Mindset</h5>
              <p>
                You're proactive, creative, and excited about growing something
                meaningful in your city.
              </p>
            </div>
          </div>

          <div className="col-md-6 col-lg-3 d-flex">
            <div className="card flex-grow-1 fori">
              <h5>Reliability</h5>
              <p>
                You're dependable and committed to putting on high-quality
                events.
              </p>
            </div>
          </div>

          <div className="col-md-6 col-lg-3 d-flex">
            <div className="card flex-grow-1 fori">
              <h5>Energy & Passion</h5>
              <p>
                You thrive in social environments and enjoy making events
                unforgettable.
              </p>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="container-fluid hiring">
        <h2>We are hiring</h2>
        <div className="row justify-content-center g-3">
          <div className="col-md-6 d-flex">
            <div className="dating flex-grow-1">
              <h4>Speed Dating Hosts</h4>
              <p>
                Welcoming guests, ensuring all attendees feel comfortable and
                have a great night. Approximately 2-3 speed dating events per
                month.
              </p>
              <div className="ti-2">
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  className="btn brow-bu text-decoration-none"
                >
                  APPLY
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-6 d-flex">
            <div className="dating flex-grow-1">
              <h4>Run Club Leaders</h4>
              <p>
                Greet all run club attendees, lead a fun warmup and a casual 5km
                run, chat with attendees after the run at the chosen coffee shop
                or pub. 3-4 run clubs per month.
              </p>
              <div className="ti-2">
                <Link
                  to="#"
                  onClick={(e) => e.preventDefault()}
                  className="btn brow-bu text-decoration-none"
                >
                  APPLY
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="container-fluid single-events together">
        <div className="row d-flex align-items-strech g-4">
          <div className="col-md-6 ood-1 d-flex">
            <div className="get-app d-flex flex-column align-items-start justify-content-center w-100">
              <h3 className="text-start">Let’s work together!</h3>
              <p className="text-start">
                If you’re a venue owner, brand manager, or business looking to
                collaborate on future YFMF events, we’d love to hear from you!
                Contact us to explore sponsorship and partnership opportunities.
              </p>
              <p className="text-start">
                YFMF works closely with Find a Venue to source our venues and
                event spaces around Ireland.
              </p>
              <div className="d-flex mb-3 w-100">
                <div className="subscribe-box">
                  <input
                    type="text"
                    name="email" value={inputsnew.email}
                    placeholder="Your email address"
                    className="form-control bg-transparent border-0"
                    onChange={handleInputChangeNew}
                  />
                </div>
                <button className="btn px-3" type="button" onClick={handleSubmitNew}>
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/another-right.svg'}
                    alt="arrow"
                    className="img-fluid"
                  />
                </button>
              </div>
              {errorsnew.email && (<p className="text-danger mt-2 text-inherit-news">{errorsnew.email}</p>)}
              <p className="text-start">
                *We respect your privacy and will never share your details.
              </p>
            </div>
          </div>

          <div className="col-md-6 ood-2 d-flex">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/together-img.png'}
              alt="Event Promo"
              className="img-fluid eve-img"
            />
          </div>
        </div>
      </div> */}
      <Appqr />
      <Footer />
      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
    </>
  );
};

export default BrandPartnership;